/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

import {InjectionToken} from '@angular/core';
import {AboutUsDataInterface} from '@shared/interface';

export const DEFAULT_ABOUT_US_DATA  = new InjectionToken<AboutUsDataInterface>('DEFAULT_ABOUT_US_DATA');
